abstract class InitError extends Error {
  abstract status: number
  abstract name: string
}

export default InitError
